import { render, staticRenderFns } from "./FullDescription.vue?vue&type=template&id=7f1251c1&scoped=true"
import script from "./FullDescription.vue?vue&type=script&lang=js"
export * from "./FullDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1251c1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f1251c1')) {
      api.createRecord('7f1251c1', component.options)
    } else {
      api.reload('7f1251c1', component.options)
    }
    module.hot.accept("./FullDescription.vue?vue&type=template&id=7f1251c1&scoped=true", function () {
      api.rerender('7f1251c1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/purchaseService/components/sections/FullDescription.vue"
export default component.exports